module.exports = __webpack_public_path__ + "static/media/emoji-svgrepo-com (3).36ee2de0.svg";